export default class RateModel {
  constructor(obj) {
    obj = obj || {};
    
    this.code = obj.code;
    this.name = obj.name;
    this.change = obj.change;
    this.ask = obj.ask;
    this.bid = obj.bid;
    this.isPtax = obj.isPtax;
  }
}